import { colors } from '../../../constants/colors';

export const setStyle = ({ width, minWidth, success }) => ({
  root: { width, minWidth },
  fieldGroup: success ? { borderBottomColor: colors.JadeGreen, borderBottomWidth: 2 } : undefined,
});
